import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getResellersApi, getResellersPaginatedApi, createResellerApi, getResellerApi, updateResellerApi, updateResellerPartialApi } from "../api/resellersApi";
import type { ResellerId } from "@KassaroAB/shared/types/ids";

export const useGetResellersQuery = () => {
  return useQuery({
    queryKey: ["resellers", "all"],
    queryFn: () => getResellersApi(),
  });
};

export const useGetResellersInfiniteQuery = () => {
  return useInfiniteQuery({
    queryKey: ["resellers"],
    queryFn: ({ pageParam }: { pageParam: string | null }) => getResellersPaginatedApi(pageParam, 20),
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (lastPage.length < 20) return undefined;
      return lastPage.length > 0 ? lastPage[lastPage.length - 1].id : undefined;
    },
  });
};

export const useGetResellerQuery = (resellerId: ResellerId | undefined) => {
  return useQuery({
    queryKey: ["resellers", resellerId],
    queryFn: () => getResellerApi(resellerId!),
    enabled: !!resellerId,
  });
};

export const useCreateResellerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: FormData) => createResellerApi(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["resellers"] });
    },
  });
};

export const useUpdateResellerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ resellerId, formData }: { resellerId: ResellerId; formData: FormData }) =>
      updateResellerApi(resellerId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["resellers"] });
    },
  });
};

export const useUpdateResellerPartialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ resellerId, reseller }: { resellerId: ResellerId; reseller: Partial<{
      brand?: string;
    }> }) => updateResellerPartialApi(resellerId, reseller),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["resellers"] });
    },
  });
};
